import {
  Box,
  BoxProps,
  ButtonProps,
  IconButton as MuiIconButton,
  Tooltip,
} from "@mui/material";
import { ENTER_TOUCH_DELAY, LEAVE_TOUCH_DELAY } from "./LightTooltip";

import React from "react";
import { createStyleSheet } from "../utils/styles";

const IconButton = (
  props: ButtonProps & {
    icon: React.ReactNode;
    tooltip: string;
    containerProps?: BoxProps;
  }
) => {
  const { icon, tooltip, containerProps, ...buttonProps } = props;
  const button = <MuiIconButton {...buttonProps}>{icon}</MuiIconButton>;
  return (
    <Box sx={styles.container} {...containerProps}>
      {buttonProps.disabled ? (
        button
      ) : (
        <Tooltip
          title={tooltip}
          enterTouchDelay={ENTER_TOUCH_DELAY}
          leaveTouchDelay={LEAVE_TOUCH_DELAY}
          onContextMenu={(event) => event.preventDefault()}
        >
          {button}
        </Tooltip>
      )}
    </Box>
  );
};

const styles = createStyleSheet({
  container: {
    alignContent: "center",
  },
});

export default IconButton;
